import { getCalculatorProductsPrice } from '~/services/calculator.service'
import type {
    ICalculatorRawSetting,
    ICalculatorSelectedValues,
    ICalculatorSetting,
    ICalculatorSettingUpdaters,
    IFieldTitlesBySlug,
} from '~/types/calculator.types'

export const sinhroperevodCalculatorRawSetting: ICalculatorRawSetting = {
    fields: [
        {
            title: 'Приемники синхронного перевода',
            slug: 'transmitters_count',
            max_count: 1000,
            default_disabled: false,
            default_hidden: false,
        },
        {
            title: 'Кол-во языков перевода',
            slug: 'language_count',
            max_count: 0,
            default_disabled: true,
            default_hidden: true,
        },
    ],
    default_values: {
        transmitters_count: 45,
        headphones: 'p303',
        languages_translation_quantity: 'prot2',
    },
    fields_modal: [
        {
            type: 'counter',
            slug: 'transmitters_count',
            prevent_hidden: false,
        },
        {
            type: 'select',
            slug: 'headphones',
            prevent_hidden: false,
        },
        {
            type: 'select',
            slug: 'languages_translation_quantity',
            prevent_hidden: false,
        },
    ],
    fields_order: [
        'transmitters_count',
        'headphones',
        'languages_translation_quantity',
    ],
    images: [
        {
            counter_from: 'transmitters_count',
            success_icon: false,
            hide_count: false,
            align: 'col',
            size: 'big',
            images: [
                {
                    image: '/assets/images/products/radioguide/jpg-png/reinvox-pro.png',
                    image_webp:
                        '/assets/images/products/radioguide/webp/reinvox-pro.webp',
                    values: {
                        headphones: 'without-headphones',
                    },
                },
                {
                    image: '/assets/images/products/radioguide/jpg-png/reinvox-pro-base.png',
                    image_webp:
                        '/assets/images/products/radioguide/webp/reinvox-pro-base.webp',
                    values: {
                        headphones: 'p303',
                    },
                },
                {
                    image: '/assets/images/products/radioguide/jpg-png/reinvox-pro-comfort.png',
                    image_webp:
                        '/assets/images/products/radioguide/webp/reinvox-pro-comfort.webp',
                    values: {
                        headphones: 'p101',
                    },
                },
                {
                    image: '/assets/images/products/radioguide/jpg-png/reinvox-pro-disposable.png',
                    image_webp:
                        '/assets/images/products/radioguide/webp/reinvox-pro-disposable.webp',
                    values: {
                        headphones: 'de300',
                    },
                },
                {
                    image: '/assets/images/products/radioguide/jpg-png/reinvox-pro-stereo.png',
                    image_webp:
                        '/assets/images/products/radioguide/webp/reinvox-pro-stereo.webp',
                    values: {
                        headphones: 'p202',
                    },
                },
            ],
        },
        {
            counter_from: '',
            success_icon: false,
            hide_count: true,
            align: 'col',
            size: 'big',
            images: [
                {
                    image: '/assets/images/products/kit/jpg-png/sinhroperevod.png',
                    image_webp:
                        '/assets/images/products/kit/webp/sinhroperevod.webp',
                    values: {
                        languages_translation_quantity: 'prot2',
                    },
                },
                {
                    image: '/assets/images/products/kit/jpg-png/sinhroperevod-2.png',
                    image_webp:
                        '/assets/images/products/kit/webp/sinhroperevod-2.webp',
                    values: {
                        languages_translation_quantity: 'prot3',
                    },
                },
                {
                    image: '/assets/images/products/kit/jpg-png/sinhroperevod-3.png',
                    image_webp:
                        '/assets/images/products/kit/webp/sinhroperevod-3.webp',
                    values: {
                        languages_translation_quantity: 'prot4',
                    },
                },
            ],
        },
    ],
    price_modificators: {
        headphones: {
            de300: 1000,
        },
    },
    prices: {},
}

export const sinhroperevodFieldTitles: IFieldTitlesBySlug = {
    headphones: 'Наушники для приемников',
    languages_translation_quantity:
        'Количество языков перевода (в том числе базовый)',
}

export const sinhroperevodUpdaters: ICalculatorSettingUpdaters = {}

export function sinhroperevodGetPrice(
    calculator: ICalculatorSetting,
    selectedValues: ICalculatorSelectedValues
): string {
    const productPrices: { [key: string]: number } = getCalculatorProductsPrice(
        calculator,
        selectedValues
    )

    const transmittersPrice: number =
        (productPrices['r100pr'] || 0) *
        Number(selectedValues.transmitters_count)

    const headphonesPrice: number =
        (productPrices.headphones || 0) *
        (calculator.price_modificators.headphones?.[selectedValues.headphones]
            ? 1
            : Number(selectedValues.transmitters_count))

    let languagePackagePrice = 0

    switch (selectedValues.languages_translation_quantity) {
        case 'prot2': {
            languagePackagePrice =
                (productPrices.languages_translation_quantity || 0) +
                (productPrices['max1'] || 0) +
                2 * (productPrices['sm1'] || 0)
            break
        }
        case 'prot3': {
            languagePackagePrice =
                (productPrices.languages_translation_quantity || 0) +
                2 * (productPrices['max2'] || 0) +
                4 * (productPrices['sm1'] || 0)
            break
        }
        case 'prot4': {
            languagePackagePrice =
                (productPrices.languages_translation_quantity || 0) +
                3 * (productPrices['max2'] || 0) +
                6 * (productPrices['sm1'] || 0)
            break
        }
        default: {
            languagePackagePrice = 0
            break
        }
    }

    const casesPrice =
        (productPrices['c145pr'] || 0) *
        Math.ceil(Number(selectedValues.transmitters_count) / 45)

    const price: number =
        transmittersPrice + headphonesPrice + languagePackagePrice + casesPrice

    return formatPrice(price)
}
